import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles()((theme: Theme) => {
	return {
		dialogContent: {
			padding: '40px 8px 0 8px',
			overflowX: 'hidden',
			[theme.breakpoints.up('sm')]: {
				padding: '40px 40px 0 40px',
			},
		},
		closeBtn: {
			position: 'absolute',
			top: 9,
			right: 9,
			'& svg': {
				width: 14,
				height: 14,
			},
		},
		actions: {
			display: 'flex',
			justifyContent: 'center',
			padding: '0 0 40px',
			'& .MuiButton-root': {
				width: 190,
			},
		},
	};
});
